export default __webpack_public_path__ + "50c16c245cf605fee050bcfb9f0a6b8b.png";